import {
  MDBDatatable,
  MDBSelect,
  MDBTable,
  MDBTableBody,
  MDBTableHead,
} from "mdb-react-ui-kit";
import React, { useEffect, useRef, useState } from "react";
import { formattedNumber } from "../AddRemoveNumbers";
import { getMisc } from "../../../../apiclients/streamsapi_bridge";

function NumbersToDestination({
  register,
  errors,
  watch,
  setValue,
  destinationTypes,
  assignedNumbersDetails,
  setassignedNumbersDetails,
  assignedErrors,
  setUpdateDestinationObj,
  updateDestinationObj,
  setupdateTempNumObj,
  updateTempNumObj,
  reloadassigned,
  setreloadassigned,
  executefalg,
  setExeuteFlag,
}) {
  const [assignedNumbers, setassignedNumbers] = useState([]);
  const [destinationsObj, setdestinationsObj] = useState({});
  const [tempNumbersObj, settempNumbersObj] = useState({});
  const [ccaasFlag, setccaasFlag] = useState(false);

  // const [executefalg, setExeuteFlag] = useState(true);

  console.log(
    "assignedErrors :::::::::::::::: " + JSON.stringify(assignedErrors)
  );

  useEffect(() => {
    if ((assignedNumbersDetails.length > 0 && executefalg) || reloadassigned) {
      setExeuteFlag(false);
      let details = [];
      if (reloadassigned) {
        setreloadassigned(false);
        details = [...assignedNumbersDetails];
      } else {
        details = assignedNumbersDetails.map((assigned) => ({
          ...assigned,
          destinations: [],
          tempNumber: [],
        }));
      }
      setassignedNumbers(details);
      // setassignedNumbersDetails(details);
      if (updateDestinationObj && updateDestinationObj.length > 0) {
        setdestinationsObj(updateDestinationObj);
      }
      if (updateTempNumObj && updateTempNumObj.length > 0) {
        settempNumbersObj(updateTempNumObj);
      }
    }
  }, [assignedNumbersDetails, executefalg, reloadassigned]);

  useEffect(() => {
    if (assignedErrors && assignedErrors.length > 0) {
      const updateerror = [...assignedNumbers];
      assignedErrors.forEach((error) => {
        const { param_name, message, position } = error;
        if (param_name.split(".").length > 0 && updateerror[position]) {
          const fieldName = param_name.split(".")[1] + "error";
          updateerror[position][fieldName] = message;
        }
      });
      console.log("value is as :::::::::::: " + JSON.stringify(updateerror));
      setassignedNumbers(updateerror);
    }
  }, [assignedErrors]);

  async function handleDestinationTypeChange(newValue, number) {
    // debugger;
    let distnationsArr = [];
    // Draft data arrives as an array; its indices ("0", "1", ...) must not be mistaken for destination type keys (AA = "1")
    const destTypeCache = Array.isArray(destinationsObj) ? {} : destinationsObj;
    if (!destTypeCache.hasOwnProperty(newValue)) {
      distnationsArr = await fetchDistinationList(newValue);
      if (distnationsArr.length > 0) {
        setdestinationsObj({ ...destTypeCache, [newValue]: distnationsArr });
        setUpdateDestinationObj({
          ...destTypeCache,
          [newValue]: distnationsArr,
        });
      }
    } else {
      distnationsArr = destTypeCache[newValue];
    }

    const updateDestination = assignedNumbers.map((destination) =>
      destination.number === number
        ? (() => {
          const { dest_typeerror, desterror, ...rest } = destination;
          return {
            ...rest,
            dest_type: newValue,
            destinations: distnationsArr,
            dest: "",
            tempNumber: [],
            temp_num: [],
          };
        })()
        : destination
    );

    setassignedNumbers(updateDestination);
    setassignedNumbersDetails(updateDestination);
    const requiredValues = updateDestination.map(
      ({ destinations, tempNumber, dest_typeerror, desterror, temp_numerror, ...rest }) => rest
    );
    setValue("assign", requiredValues, { shouldDirty: true });
    if (newValue && parseInt(newValue) === 14) {
      setccaasFlag(true);
    }
  }

  async function fetchDistinationList(value) {
    console.log(sessionStorage.getItem("admin_session"));
    const response = await getMisc(
      JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      { misc: ["tn_dest"], value: parseInt(value) }
    );
    if (!response.json) {
      const message = `An error has occured: ${response.statusText}`;
      return null;
    }
    const tdata = await response.json();
    if (!tdata) {
      window.alert(`info with id  not found`);
    }

    console.log(
      "tdata ::::::::::::::::::::::::::::::::::: " + JSON.stringify(tdata)
    );
    return tdata?.misc?.tn_dest ?? [];
  }

  async function handleDestinations(newValue, number, destinationType) {
    let numberArray = [];
    if (!destinationsObj.hasOwnProperty(newValue)) {
      const tempArray = await fetchPhoneNumbers(newValue, destinationType);
      numberArray = (tempArray || []).map((entry) => ({
        text: entry,
        value: entry,
      }));
      if (numberArray.length > 0) {
        settempNumbersObj({ ...tempNumbersObj, [newValue]: numberArray });
        setupdateTempNumObj({ ...tempNumbersObj, [newValue]: numberArray });
      }
    } else {
      numberArray = tempNumbersObj[newValue];
    }
    const updateDestination = assignedNumbers.map((destination) =>
      destination.number === number
        ? (() => {
          const { desterror, dest_typeerror, ...rest } = destination;
          return {
            ...rest,
            dest: newValue + "",
            tempNumber: numberArray,
            temp_num: [],
          };
        })()
        : destination
    );

    setassignedNumbers(updateDestination);
    setassignedNumbersDetails(updateDestination);
    const requiredValues = updateDestination.map(
      ({ destinations, tempNumber, dest_typeerror, desterror, temp_numerror, ...rest }) => rest
    );
    setValue("assign", requiredValues, { shouldDirty: true });
  }

  async function fetchPhoneNumbers(value, destinationType) {
    console.log(sessionStorage.getItem("admin_session"));
    const response = await getMisc(
      JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      {
        misc: ["temp_num"],
        assignedto: parseInt(destinationType),
        uniqueid: parseInt(value),
      }
    );
    if (!response.json) {
      const message = `An error has occured: ${response.statusText}`;
      return null;
    }
    const tdata = await response.json();
    if (!tdata) {
      window.alert(`info with id  not found`);
    }
    console.log(
      "tdata number::::::::::::::::::::::::::::::::::: " + JSON.stringify(tdata)
    );
    return tdata?.misc?.temp_num ?? [];
  }

  const handlePhoneNumbers = async (phoneArray, number) => {
    console.log(phoneArray); // Log the value to see when it's called
    const newValues = phoneArray?.map((ph) => ph.value);
    const currentValues = assignedNumbers.find(
      (destination) => destination.number === number
    )?.temp_num;

    if (JSON.stringify(newValues) !== JSON.stringify(currentValues)) {
      const updateDestination = assignedNumbers?.map((destination) =>
        destination.number === number
          ? (() => {
            const { temp_numerror, ...rest } = destination;
            return { ...rest, temp_num: newValues };
          })()
          : destination
      );
      await setassignedNumbers(updateDestination);
      setassignedNumbersDetails(updateDestination);
      const requiredValues = updateDestination.map(
        ({ destinations, tempNumber, dest_typeerror, desterror, temp_numerror, ...rest }) => rest
      );
      setValue("assign", requiredValues, { shouldDirty: true });
    }
  };

  useEffect(() => {
    if (assignedNumbers?.length > 0 && ccaasFlag) {
      setccaasFlag(false);
      assignedNumbers.forEach((info) => {
        if (parseInt(info.dest_type) === 14 && !info.dest) {
          // Call handleDestinations automatically
          const siteid = JSON.parse(
            sessionStorage.getItem("admin_session")
          ).siteid;
          handleDestinations(siteid, info.number, info.dest_type);
        }
      });
    }
  }, [assignedNumbers, ccaasFlag]);

  // const debouncedHandlePhoneNumbers = useDebounce(handlePhoneNumbers, 1000);

  let processdrows = [];
  assignedNumbers.map((info) => {
    processdrows.push({
      assignInfo: info,
      TransferNumber: formattedNumber(info.number + ""),
      DestinationType: (
        <>
          <div className="select-wrapper">
            <div className="form-outline">
              <select
                name=""
                id=""
                // Without an associated <label>/aria-label, a native <select>
                // falls back to an accessible name made by concatenating every
                // <option>'s text, which some browsers surface as the hover
                // tooltip - with no title to override it, that shows all
                // destination types run together instead of just the current
                // selection. An explicit title mirroring what's actually
                // shown/selected prevents that fallback.
                title={(Array.isArray(destinationTypes) ? destinationTypes.find((destination) => destination.value === info.dest_type) : undefined)?.name ?? "Select Type"}
                className="form-control select-input form-select"
                value={info.dest_type}
                onChange={(e) => {
                  e.preventDefault();
                  handleDestinationTypeChange(e.target.value, info.number);
                }}
              >
                <option value="">Select Type</option>
                {destinationTypes &&
                  destinationTypes.length > 0 &&
                  destinationTypes.map((destination) => (
                    <option value={destination.value}>
                      {destination.name}
                    </option>
                  ))}
              </select>
            </div>
          </div>
          {info?.dest_typeerror && (
            <p className="text-danger">{info?.dest_typeerror}</p>
          )}
        </>
      ),
      Destination: (
        <>
          <div className="select-wrapper">
            <div className="form-outline">
              <select
                name=""
                id=""
                // Same native fallback-tooltip issue as the Destination Type
                // select above - this one doesn't show it yet only because it
                // currently has just one option before a type is picked; once
                // populated with real destinations it would too.
                title={(Array.isArray(info.destinations) ? info.destinations.find((dest) => parseInt(dest.uniqueid) === parseInt(info.dest)) : undefined)?.title ?? "Select Destination"}
                className="form-control select-input form-select"
                value={parseInt(info.dest)}
                onChange={(e) => {
                  e.preventDefault();
                  handleDestinations(
                    e.target.value,
                    info.number,
                    info.dest_type
                  );
                }}
              >
                {info.dest_type != 14 && (
                  <option value="">Select Destination</option>
                )}
                {info.destinations &&
                  info.destinations.length > 0 &&
                  info.destinations.map((dest) => (
                    <option value={parseInt(dest.uniqueid)}>
                      {dest.title}
                    </option>
                  ))}
              </select>
            </div>
          </div>
          {info?.desterror && <p className="text-danger">{info?.desterror}</p>}
        </>
      ),
      TemporaryNumber: (
        <>
          <MDBSelect
            multiple
            search
            data={info?.tempNumber ?? []}
            value={info?.temp_num ?? []}
            onSelect={(e) => e.preventDefault()}
            onChange={(value) => {
              if (value) {
                //console.log(value);
                handlePhoneNumbers(value, info.number);
              }
            }}
          />
          {info?.temp_numerror && (
            <p className="text-danger">{info?.temp_numerror}</p>
          )}
        </>
      ),
    });
  });

  const advancedData = {
    columns: [
      { label: "Transfer Number", field: "TransferNumber" },
      { label: "Destination Type", field: "DestinationType" },
      { label: "Destination", field: "Destination" },
      { label: "Temporary Number	", field: "TemporaryNumber" },
    ],
    rows: processdrows,
  };

  // console.log("processdrows :::::::::: "+processdrows.length);
  return (
    <>
      <div className="pb-3">
        <h5>Assign Number(s) to Respective Destination(s)</h5>
        <strong className="pt-3">
          Replace temporary number with transfer number
        </strong>
        <p className="mt-2">
          To replace an assigned temporary number with transfer number for any
          destination, select the destination type, destination and then select
          the temporary number(s) from displayed temporary numbers list that you
          want to replace with transfer number. If no temporary number is
          selected after selecting destination for any transfer number then the
          transfer number will be assigned to respective destination on
          completion of Porting process.
        </p>
      </div>
      <div className="TNLocalNumTable">
        <div className="position-relative tnTable">
          <table className="sticky-table">
            <thead>
              <tr>
                <th scope="col" width="25%">
                  Transfer Number
                </th>
                <th scope="col" width="25%">
                  Destination Type
                </th>
                <th scope="col" width="25%">
                  Destination
                </th>
                <th scope="col" width="25%">
                  Temporary Number
                </th>
              </tr>
            </thead>
            <tbody>
              {processdrows.map((row, index) => (
                <tr key={index}>
                  <td width="25%">
                    {row.TransferNumber}
                  </td>
                  <td width="25%">
                    {row.DestinationType}
                  </td>
                  <td width="25%">
                    {row.Destination}
                  </td>
                  <td width="25%">
                    {row.TemporaryNumber}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* <MDBDatatable
          data={advancedData}
          // pagination={false}
          entries={50}
          maxHeight="calc(100vh - 420px)"
          fixedHeader
          sortField="Transfer Number"
        /> */}
      </div>
    </>
  );
}

export default NumbersToDestination;

function useDebounce(callback, delay) {
  const timer = useRef(null);

  return (...args) => {
    if (timer.current) {
      clearTimeout(timer.current);
    }
    timer.current = setTimeout(() => {
      callback(...args);
    }, delay);
  };
}
